import HallEditForm from "./hall-edit-form";

export default HallEditForm;